// -----------------
// Enums

export const schoolAlternativeDecisionEnum = {
  None: 0,
  Accepted: 1,
  Rejected: 2,
};

export const AlternativeStatusEnum = {
  Yes: 1,
  InProcess: 2,
  No: 3,
};

// --------------------------------------------------------------------
// Models
//
// SchoolRecommendationModel
// {
//   region: {  id: number, name: string }
//   municipality: {  id: number, name: string }
//   school: {  id: number, name: string }
//   alternatives: SchoolRecommendationAlternativeModel[]
//   reason: string
// }
//
// SchoolRecommendationAlternativeModel
// {
//   id: number
//   category: string
//   description: string
//   decision: schoolAlternativeDecisionEnum
//   reason: string
//   reasonDate: string
// }
//
// --------------------------------------------------------------------
// Payloads dtos
//
// SchoolRecommendationDto
// {
//   id: number
//   locationSchoolId: number
//   reason: string
//   tapRequestSchoolAlternativeLocations: SchoolRecommendationAlternativeDto[]
// }
//
// SchoolRecommendationAlternativeDto
// {
//   id: number
//   alternativeId: number
//   reason: string
//   reasonDate: string
//   decision: schoolAlternativeDecisionEnum
// }
//
// --------------------------------------------------------------------
// Return dtos
//
// SchoolRecommendationReturnDto
// {
//   id: number
//   region: {  id: number, name: string }
//   municipality: {  id: number, name: string }
//   locationSchool: {  id: number, name: string }
//   reason: string
//   tapRequestSchoolAlternativeLocations: SchoolRecommendationAlternativeReturnDto[]
// }
//
// SchoolRecommendationAlternativeReturnDto
// {
//   id: number
//   alternativeId: number
//   reason: string
//   reasonDate: string
//   decision: schoolAlternativeDecisionEnum
//   tapSchoolAlternativeLocation: {
//     id: number
//     alternativeLocation: {
//       id: number
//       category: string
//       description: string
//     }
//   }
// }
//
// SchoolAlternativeDto
// {
//   alternativeLocationId: number
//   alternativeLocation: {
//     category: string
//     description: string
//   }
// }
